if (!customElements.get('back-in-stock-form')) {
  customElements.define(
    'back-in-stock-form',
    class BackInStockForm extends HTMLElement {
      constructor() {
        super();
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        try {
          this.sectionId = this.dataset.sectionId;
          this.form = this.querySelector('form');
          this.bodyField = this.querySelector('[data-back-in-stock-body]');
          this.buyButtons = this.closest('.product__info-container')?.querySelector('[data-buy-buttons-wrapper]');
          if (!this.form || !this.buyButtons) return;
          this.form.addEventListener('submit', this.onSubmit);
          this.variantUnsubscriber =
            typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
              ? subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange)
              : null;
          this.closest('product-info')?.addEventListener('variant:changed', this.onVariantChange);
          this.syncFromDom();
        } catch (error) {
          console.error(error);
        }
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
        this.variantUnsubscriber?.();
        this.closest('product-info')?.removeEventListener('variant:changed', this.onVariantChange);
      }

      onVariantChange(event) {
        const detail = event?.detail || event?.data || event;
        const payload = detail?.data || detail;
        if (payload?.sectionId && payload.sectionId !== this.sectionId) return;
        this.render(payload?.variant);
      }

      syncFromDom() {
        const variantJson = this.closest('product-info')?.querySelector('variant-selects [data-selected-variant]')?.textContent;
        if (!variantJson) return;
        this.render(JSON.parse(variantJson));
      }

      render(variant) {
        const soldOut = Boolean(variant) && variant.available === false;
        this.dataset.visible = String(soldOut);
        this.buyButtons.classList.toggle('back-in-stock-hidden', soldOut);
        if (this.bodyField && variant?.id) {
          this.bodyField.value = `Back-in-stock request: ${this.dataset.productHandle} | variant ${variant.id}`;
        }
        if (!soldOut) this.dataset.success = 'false';
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.form.reportValidity()) return;
        const email = this.form.querySelector('input[type="email"]');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email.value.trim())) {
          email.setCustomValidity('Bitte gib eine gueltige E-Mail-Adresse ein.');
          email.reportValidity();
          email.setCustomValidity('');
          return;
        }
        const body = new URLSearchParams(new FormData(this.form));
        try {
          const response = await fetch(`${this.form.action}#back-in-stock`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: body.toString(),
          });
          if (!response.ok) throw new Error(`Request failed: ${response.status}`);
          this.dataset.success = 'true';
          this.form.reset();
        } catch (error) {
          console.error(error);
        }
      }
    }
  );
}
